import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import { formatTranslation } from 'v2/utils/formatTranslation';

interface Props {
  deviceGroupName: string;
  onConfirm: () => Promise<void>;
}

const DeleteDeviceGroupModal: React.FC<Props> = ({ deviceGroupName, onConfirm }) => {
  const { translation } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await onConfirm();
  };

  return (
    <ModalTemplate
      title={`${translation.delete} "${deviceGroupName}"?`}
      primaryAction={{
        id: 'confirm-delete-device-group-button',
        label: translation.delete,
        onClick: handleClick,
        dangerzone: true,
        loading: isLoading
      }}
      secondaryAction={{
        id: 'cancel-button',
        label: translation.cancel
      }}
    >
      <Stack spacing={3}>
        <Typography>
          {formatTranslation(translation.delete_device_group_confirmation, { name: deviceGroupName })}{' '}
          {translation.access_rights_revoked_notice}
        </Typography>
      </Stack>
    </ModalTemplate>
  );
};

export default DeleteDeviceGroupModal;
